import api from './axios';

export const getUsuarios = () =>
  api.get('/usuarios').then((r) => r.data);

export const createUsuario = (data) =>
  api.post('/usuarios', data).then((r) => r.data);

export const updateUsuario = (id, data) =>
  api.patch(`/usuarios/${id}`, data).then((r) => r.data);
